import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { map } from 'rxjs/operators';
import { UserManagementService } from './user-management.service';
import { ModalAccountComponent } from './modal-account.component';
import { ModalAddAccountComponent } from './modal-add-account.component';
import { GobalFunctionService } from 'src/app/core/services/gobal/gobal-function.service';

@Component({
  selector: 'app-user-management',
  templateUrl: './user-management.component.html',
  styleUrls: ['./user-management.component.scss']
})
export class UserManagementComponent implements OnInit {
  dialogConfig = new MatDialogConfig();
  tableName: string = 'user';
  formDialog;
  accounts: any;
  collectionSize: number;
  page: number = 1;
  pageSize: number = 10;
  rows: any[];
  search: string;
  isSearch: boolean = false;
  searchAccounts: any = '';

  // column ต้องตั้งอันแรกเป็น field ID เสมอ ใช้ในการเช็ค EDIT
  columnUser = [{
    field: 'USER_ID',
    header: 'รหัสผู้ใช้งาน',
    style: 'col'
  }, {
    field: 'USERNAME',
    header: 'ชื่อ',
    style: 'col-2'
  }, {
    field: 'EMAIL',
    header: 'อีเมล',
    style: 'col-4'
  }, {
    field: 'USER_RANK',
    header: 'ประเภทสมาชิก',
    style: 'col'
  }, {
    field: 'ACTIVE_USER',
    header: 'สถานะ',
    style: 'col'
  }, {
    field: 'SEE_DETAIL',
    header: 'ดูรายละเอียด',
    role: 'user',
    style: 'col'
  }]

  columnTeacher = [{
    field: 'TEACHER_ID',
    header: 'รหัสอาจารย์',
    style: 'col'
  }, {
    field: 'USERNAME',
    header: 'ชื่อ',
    style: 'col-2'
  }, {
    field: 'EMAIL',
    header: 'อีเมล',
    style: 'col-4'
  }, {
    field: 'ACTIVE_USER',
    header: 'สถานะ',
    style: 'col'
  }, {
    field: 'SEE_DETAIL',
    header: 'ดูรายละเอียด',
    role: 'teacher',
    style: 'col'
  }]

  columnPsychologist = [{
    field: 'PSYCHOLOGIST_ID',
    header: 'รหัสนักจิตวิทยา',
    style: 'col'
  }, {
    field: 'USERNAME',
    header: 'ชื่อ',
    style: 'col-2'
  }, {
    field: 'EMAIL',
    header: 'อีเมล',
    style: 'col-4'
  }, {
    field: 'ACTIVE_USER',
    header: 'สถานะ',
    style: 'col'
  }, {
    field: 'SEE_DETAIL',
    header: 'ดูรายละเอียด',
    role: 'psychologist',
    style: 'col'
  }]

  columnAdmin = [{
    field: 'ADMIN_ID',
    header: 'รหัสแอดมิน',
    style: 'col'
  }, {
    field: 'USERNAME',
    header: 'ชื่อ',
    style: 'col-2'
  }, {
    field: 'EMAIL',
    header: 'อีเมล',
    style: 'col-4'
  }, {
    field: 'ACTIVE_USER',
    header: 'สถานะ',
    style: 'col'
  }, {
    field: 'SEE_DETAIL',
    header: 'ดูรายละเอียด',
    role: 'admin',
    style: 'col'
  }]
  column = this.columnUser;

  constructor(
    public matDialog: MatDialog,
    private userManagementService: UserManagementService,
    private gobalFunctionService: GobalFunctionService
  ) {
  }

  ngOnInit() {
    this.manageTable('user');
    this.gobalFunctionService.setTitle('การจัดการผู้ใช้งาน');
  }

  refresh() {
    this.collectionSize = this.accounts.length;
    this.rows = this.accounts
      .map((account, i) => ({ id: i + 1, ...account }))
      .slice((this.page - 1) * this.pageSize, (this.page - 1) * this.pageSize + this.pageSize);
  }

  refreshSearch() {
    this.collectionSize = this.searchAccounts.length;
    this.rows = this.searchAccounts
      .map((account, i) => ({ id: i + 1, ...account }))
      .slice((this.page - 1) * this.pageSize, (this.page - 1) * this.pageSize + this.pageSize);
  }

  searching() {
    if (this.search !== '') {
      this.isSearch = true;
      this.searchAccounts = [];
      this.accounts.filter(account => {
        if (account.EMAIL.toLowerCase().includes(this.search.toLowerCase())) {
          this.searchAccounts.push(account)
        }
      });
      this.refreshSearch();
    } else {
      this.isSearch = false
      this.searchAccounts = null;
      this.refresh();
    }
  }

  manageTable(m) {
    this.tableName = m;
    if (m === 'user') {
      this.column = this.columnUser;
    } else if (m === 'admin') {
      this.column = this.columnAdmin;
    } else if (m === 'teacher') {
      this.column = this.columnTeacher;
    } else if (m === 'psychologist') {
      this.column = this.columnPsychologist;
    }
    return this.userManagementService.getTable(m).subscribe(res => {
      // // console.log(res);
      this.accounts = res.result;
      this.collectionSize = this.accounts.length;

      this.statusToText();

      this.rows = this.accounts
        .map((account, i) => ({ id: i + 1, ...account }))
        .slice((this.page - 1) * this.pageSize, (this.page - 1) * this.pageSize + this.pageSize);

      this.refresh();
    });
  }

  addAccount(role) {
    this.dialogConfig.disableClose = true;
    this.dialogConfig.id = "modalAddAccount";
    this.dialogConfig.data = {
      name: "consent",
      title: "สร้าง account ",
      role: role,
      isEdit: false,
      actionBtnText: "สร้าง",
      cancleBtnText: "ยกเลิก",
      customStyle: 'min-width: 600px;'
    }
    this.formDialog = this.matDialog.open(ModalAddAccountComponent, this.dialogConfig);
    this.formDialog.afterClosed().subscribe(() => {
    }, err => {

    }, complete => {
      this.manageTable(this.tableName);
    })
  }

  seeDetail(row, role: string) {
    // // console.log(row);
    this.dialogConfig.disableClose = true;
    this.dialogConfig.id = "modalEditAccount";
    this.dialogConfig.autoFocus = false;
    this.dialogConfig.data = {
      row: row,
      name: row.USERNAME,
      isEdit: true,
      status: row.ACTIVE_USER,
      role: role,
      actionBtnText: "บันทึก",
      // cancleBtnText: "ปิด",
      customStyle: "min-width: 550px"
    }

    if (role === 'user') {
      this.dialogConfig.data['id'] = row.USER_ID;
    } else if (role === 'teacher') {
      this.dialogConfig.data['id'] = row.TEACHER_ID;
    } else if (role === 'psychologist') {
      this.dialogConfig.data['id'] = row.PSYCHOLOGIST_ID;
    } else if (role === 'admin') {
      this.dialogConfig.data['id'] = row.ADMIN_ID;
    }

    this.formDialog = this.matDialog.open(ModalAccountComponent, this.dialogConfig);
    this.formDialog.afterClosed().pipe(
      map(() => {
        this.manageTable(role)
      })
    ).subscribe()
  }

  statusToText() {
    for (let i = 0; i < this.accounts.length; i++) {
      if (this.accounts[i].ACTIVE_USER === 0) {
        this.accounts[i]['ACTIVE_USER'] = 'Active'
      } else if (this.accounts[i].ACTIVE_USER === 1) {
        this.accounts[i]['ACTIVE_USER'] = 'Deactivate'
      } else if (this.accounts[i].ACTIVE_USER === 4) {
        this.accounts[i]['ACTIVE_USER'] = 'Ban'
      } else if (this.accounts[i].ACTIVE_USER === 99) {
        this.accounts[i]['ACTIVE_USER'] = 'Wait Verify'
      }
    }
  }
}
